<!-- Courses -->
<section *ngIf="!course">
  <!-- Page Header -->
  <div class="header">
      <!-- Page Title -->
      <div class="title">
        <h1>Courses Content</h1>
      </div>

      <div class="d-flex">
        <!-- Back -->
        <div>
          <button type="button" [disabled]="true" class="back btn custom text-primary mr-2" (click)="goBack()"><mdb-icon fas icon="arrow-circle-left"></mdb-icon></button>
        </div>

        <!-- Breadcrumbs -->
        <ul class="breadcrumbs">
          <li>All</li>
          <li>Courses</li>
        </ul>
      </div>
  </div>

  <!-- List of Courses -->
  <div class="courses-list card py-5" *ngIf="courses?.length">
      <!-- Individual Courses -->
      <div *ngFor="let course of courses" class="content-box course selectable" (click)="onCourse(course)">
        <h1>{{courseName(course)}}</h1>
      </div>
  </div>
</section>


<!-- Course Modules -->
<section *ngIf="course && !moduleID">
  <!-- Page Header -->
  <div class="header">
      <!-- Page Title -->
      <div class="title">
        <h1>Courses Content</h1>
      </div>

      <div class="d-flex">
        <!-- Back -->
        <div>
          <button type="button" class="back btn custom text-primary mr-2" (click)="goBack()"><mdb-icon fas icon="arrow-circle-left"></mdb-icon></button>
        </div>

        <!-- Breadcrumbs -->
        <ul class="breadcrumbs">
          <li><a [routerLink]="" (click)="open('', '')">All</a></li>
          <li>{{courseName(course)}} Modules</li>
        </ul>

        <!-- Add Module -->
        <div>
          <button type="button" class="dt-button" (click)="addModuleDialog()">
            <mdb-icon class="text-success mr-1" fas icon="plus" size="md"></mdb-icon>
            <span>Add Module</span>
          </button>
        </div>
      </div>
  </div>

  <div class="card">
      <div class="card-body" style="overflow-x:auto;">
          <!-- Table -->
          <table datatable #modulesTable [dtOptions]="dtOptionsModules" [dtTrigger]="dtTriggerModules" class="table-striped stripe hover row-border order-column">
              <!-- Head -->
              <thead>
                  <tr>
                      <th>#</th>
                      <th class="th-title">Module Title</th>
                      <th>Creation Date</th>
                      <th>Last Modified</th>
                      <th>Actions</th>
                  </tr>
              </thead>

              <!-- Body -->
              <tbody>
                  <tr *ngFor="let m of modules; index as index; first as first; last as last">
                      <td class="td-num" [attr.data-sort]="index">
                        <a [routerLink]="" (click)="openModule(index)">Module {{index + 1}}.</a>
                      </td>
                      <td [class.text-muted]="!m.title">{{m.title || 'No title'}}</td>
                      <td class="nowrap">{{m.created | date}}</td>
                      <td>{{m.lastUpdated | date:'medium'}}</td>
                      <td class="td-actions">
                        <div class="move-buttons">
                          <mdb-icon fas icon="arrow-circle-up" class="text-info icon icon-up" (click)="moveModuleUp(index)" [class.disabled]="first"></mdb-icon>
                          <mdb-icon fas icon="arrow-circle-down" class="text-info icon icon-down" (click)="moveModuleDown(index)" [class.disabled]="last"></mdb-icon>
                        </div>

                        <a [routerLink]="['/admin/quiz-questions']" class="mr-2" [queryParams]="{
                          courseid: courseID,
                          moduleid: m.moduleID
                        }">
                          <button type="button">Quiz</button>
                        </a>

                        <button type="button" (click)="editModule(index)"><mdb-icon fas icon="pen"></mdb-icon></button>

                        <button type="button" (click)="deleteModule(index)" class="btn-danger ml-2"><mdb-icon fas icon="trash"></mdb-icon></button>
                      </td>
                  </tr>
              </tbody>
          </table>
      </div>
  </div>
</section>


<!-- Course Module Pages -->
<section *ngIf="course && moduleID">
  <!-- Page Header -->
  <div class="header">
    <!-- Page Title -->
    <div class="title">
      <h1>Courses Content</h1>
    </div>

    <div class="d-flex">
      <!-- Back -->
      <div>
        <button type="button" class="back btn custom text-primary mr-2" (click)="goBack()"><mdb-icon fas icon="arrow-circle-left"></mdb-icon></button>
      </div>

      <!-- Breadcrumbs -->
      <ul class="breadcrumbs">
        <li><a [routerLink]="" (click)="open('', '')">All</a></li>
        <li><a [routerLink]="" (click)="open(courseID, '')">{{courseName(course)}} Modules</a></li>
        <li *ngIf="module">{{module.moduleNumber}}. {{module.title}}</li>
      </ul>

      <!-- Add Page -->
      <div>
        <a [routerLink]="['/admin/admin-courses/edit-page']" [queryParams]="{
          courseid: courseID,
          moduleid: moduleID,
          pageid:   'new'
        }">
          <button type="button" class="dt-button">
            <mdb-icon class="text-success mr-1" fas icon="plus" size="md"></mdb-icon>
            <span>Add Page</span>
          </button>
        </a>
      </div>
    </div>
  </div>

  <div class="card" *ngIf="module">
      <div class="card-body" style="overflow-x:auto;">
          <!-- Table -->
          <table datatable #pagesTable [dtOptions]="dtOptionsPages" [dtTrigger]="dtTriggerPages" class="table-striped stripe hover row-border order-column">
              <!-- Head -->
              <thead>
                  <tr>
                      <th>#</th>
                      <th class="th-title">Page Title</th>
                      <th class="th-pagetype">Page Type</th>
                      <th>Creation Date</th>
                      <th>Last Modified</th>
                      <th>Actions</th>
                  </tr>
              </thead>

              <!-- Body -->
              <tbody>
                  <tr *ngFor="let p of pages; index as index; first as first; last as last">
                      <td class="td-num" [attr.data-sort]="index">
                        <a [routerLink]="['/admin/admin-courses/preview', courseID, 'm', moduleID]" [queryParams]="{ pageid: p.pageID }">Page {{index + 1}}.</a>
                      </td>
                      <td [class.text-muted]="!p.title">{{p.title || 'No title'}}</td>
                      <td>
                        <div>{{p.type}}</div>
                        <div *ngIf="p.type !== 'Custom'" class="text-muted">{{p.content}}</div>
                      </td>
                      <td class="nowrap">{{p.created | date}}</td>
                      <td>{{p.lastUpdated | date:'medium'}}</td>
                      <td class="td-actions">
                        <div class="move-buttons">
                          <mdb-icon fas icon="arrow-circle-up" class="text-info icon icon-up" (click)="movePageUp(index)" [class.disabled]="first"></mdb-icon>
                          <mdb-icon fas icon="arrow-circle-down" class="text-info icon icon-down" (click)="movePageDown(index)" [class.disabled]="last"></mdb-icon>
                        </div>

                        <a class="ml-2" [routerLink]="['/admin/admin-courses/preview', courseID, 'm', moduleID]" [queryParams]="{ pageid: p.pageID }">
                          <button class="button-preview" type="button" (click)="previewPage($event, index)"><mdb-icon fas icon="eye"></mdb-icon></button>
                        </a>

                        <a class="ml-2" [routerLink]="['/admin/admin-courses/edit-page']" [queryParams]="{
                          courseid: courseID,
                          moduleid: moduleID,
                          pageid:   p.pageID
                        }">
                          <button class="button-edit" type="button"><mdb-icon fas icon="pen"></mdb-icon></button>
                        </a>

                        <button class="button-delete btn-danger ml-2" type="button" (click)="deletePage(index)"><mdb-icon fas icon="trash"></mdb-icon></button>
                      </td>
                  </tr>
              </tbody>
          </table>
      </div>
  </div>
</section>
